'use client';

// This is a full screen takeover! Components can be placed in the modal
// and will be displayed in the center of the screen.

import { ReactNode, forwardRef } from 'react';

export interface ModalFullScreenProps {
	testId?: string;
	children: ReactNode;
	closeButton?: ReactNode;
}

const ModalFullScreen = forwardRef<HTMLDialogElement, ModalFullScreenProps>(
	(props, ref) => {
		const { testId = 'ModalFullScreen', children, closeButton } = props;

		if (typeof window === 'undefined') {
			return null;
		}

		return (
			<dialog
				ref={ref}
				data-testid={testId}
				className="fixed top-0 z-20 block h-full max-h-full w-full max-w-full p-4 md:p-10"
			>
				{closeButton && (
					<div className="absolute top-20 md:top-10">{closeButton}</div>
				)}

				<div className="flex h-full w-full flex-col items-center justify-center ">
					<div className="overflow-y-auto py-6 md:py-0">{children}</div>
				</div>
			</dialog>
		);
	},
);

ModalFullScreen.displayName = 'ModalFullScreen';

export default ModalFullScreen;
